import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaceCoreModule } from '@evorait/pace-core';
import { MaterialQuoteComponent } from './material-quote/material-quote.component';
import { CseSalesTidInputComponent } from './cse-sales-tid-input/cse-sales-tid-input.component';
import { MaterialOrderComponent } from './material-order/material-order.component';
import { MaterialOrderRowDetailsComponent } from './material-order/material-order-row-details/material-order-row-details.component';
import { MaterialInventoryComponent } from './material-inventory/material-inventory.component';
import { SharedModule } from '../shared/shared.module';
import { CoreModule } from '../core/core.module';
import { MaterialAvailabilityComponent } from './material-availability/material-availability.component';
import { MaterialHistoryComponent } from './material-history/material-history.component';
import { FormsModule } from '@angular/forms';
import { MaterialPricingComponent } from './material-pricing/material-pricing.component';
import { MaterialOrderPricingComponent } from './material-order-pricing/material-order-pricing.component';
import { CseMaterialListComponent } from './cse-material-list/cse-material-list.component';
import { MaterialReturnP58Component } from './material-return-p58/material-return-p58.component';
import { MaterialPricingDetailsExpandableComponent } from './material-pricing-details-expandable/material-pricing-details-expandable.component';
import { MaterialAvailabilityDetailsComponent } from './material-availability/material-availability-details/material-availability-details.component';
import { MaterialHistoryDetailComponent } from './material-history/material-history-detail/material-history-detail.component';
import { MaterialReturnP58DetailComponent } from './material-return-p58/material-return-p58-detail/material-return-p58-detail.component';

@NgModule({
    declarations: [
        MaterialHistoryDetailComponent,
        MaterialQuoteComponent,
        CseSalesTidInputComponent,
        MaterialOrderComponent,
        MaterialOrderRowDetailsComponent,
        MaterialInventoryComponent,
        MaterialAvailabilityComponent,
        MaterialHistoryComponent,
        MaterialPricingComponent,
        MaterialOrderPricingComponent,
        CseMaterialListComponent,
        MaterialReturnP58Component,
        MaterialPricingDetailsExpandableComponent,
        MaterialAvailabilityDetailsComponent,
        MaterialReturnP58DetailComponent,
    ],
    imports: [CommonModule, SharedModule, CoreModule, FormsModule, PaceCoreModule.forChild()],
    exports: [
        MaterialInventoryComponent,
        MaterialOrderComponent,
        MaterialQuoteComponent,
        CseSalesTidInputComponent,
        MaterialAvailabilityComponent,
        MaterialHistoryComponent,
        CseMaterialListComponent,
        MaterialReturnP58Component,
        MaterialAvailabilityDetailsComponent,
        MaterialReturnP58DetailComponent,
    ],
})
export class MaterialModule {}
